import React from 'react';
import {FilePond, registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import {HEIGHT_IMAGE, MAXFILESIZE, MAXTOTALFILESIZE, FILE_NAMES} from '../../constants';
registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilePondPluginFileRename);

// eslint-disable-next-line max-params
function renderFileUpload(image, name, handleImages, index) {
  return (
    <FilePond
      key={index}
      imagePreviewMinHeight={HEIGHT_IMAGE}
      maxFileSize={MAXFILESIZE}
      maxTotalFileSize={MAXTOTALFILESIZE}
      acceptedFileTypes={['image/png', 'image/jpeg', 'image/gif']}
      allowMultiple={false}
      files={image}
      fileRenameFunction = {(file) => `${name}${file.extension}` }
      onupdatefiles={(fileItems) => handleImages(fileItems, name)}
      labelIdle='Arrastrar archivo o <span class="filepond--label-action">Navegador</span>'
    />
  );
}

const FilesUpload = ({side, frontal, back, inner, board, document, others, handleImages, pdfLink}) => {
  const images = [side, frontal, back, inner, board];
  return (
    <div>
      <div className="tcc-files mt">
        {images.map((image, index) => renderFileUpload(image, FILE_NAMES[index], handleImages, index + 1))}
      </div>
      <div className="tcc-files-bottom mt mb-3">
        <div>
          <h5>Carga de formulario de inspección (solo admite PDF)
            <a download className="tcc-link" href={`${process.env.PUBLIC_URL}/media/tcc/TCC.pdf`}>
                Descargar formulario
            </a>
          </h5>
          <FilePond
            // disabled={validateStatus}
            maxFileSize={MAXFILESIZE}
            maxTotalFileSize={MAXTOTALFILESIZE}
            acceptedFileTypes={['application/pdf']}
            files={document}
            fileRenameFunction = {(file) => `document${file.extension}` }
            allowMultiple={false}
            onupdatefiles={(fileItems) => handleImages(fileItems, 'document')}
            labelIdle='Arrastrar archivo o <span class="filepond--label-action">Navegador</span>'
          />
          {pdfLink && (
            <div className="tcc-pdf-preview">
              <h5>Ver formulario de inspección</h5>
              <div className="tcc-pdf-preview-bg">
                <a target="_blank" rel="noreferrer" className="tcc-pdf-preview-bg-link" href={pdfLink}>
                  <img
                    className="tcc-pdf-preview-bg-image"
                    src={`${process.env.PUBLIC_URL}/media/tcc/TCC-PREVIEW.png`}
                    alt=""
                  />
                </a>
              </div>
            </div>
          )}
        </div>

        <div>
          <h5>Cargar imágenes adicionales (Opcionales)</h5>
          <FilePond
            maxFileSize={MAXFILESIZE}
            maxTotalFileSize={MAXTOTALFILESIZE}
            acceptedFileTypes={['image/png', 'image/jpeg', 'image/gif']}
            files={others}
            allowMultiple={true}
            fileRenameFunction = {(file) => `${file.name}` }
            onupdatefiles={(fileItems) => handleImages(fileItems, 'others')}
            labelIdle='Arrastrar archivo o <span class="filepond--label-action">Navegador</span>'
          />
        </div>
      </div>
    </div>
  );
};

export default FilesUpload;
